import { fixedUi } from '@/i18n/fixedUi';
import React from 'react';
import CategoryCascader from '@/shein-platform/components/CategoryCascader';

export default function ShopCategoryPanel({
  loading,
  error,
  categories,
}) {
  return (
    <div className="spo-shop-info__panel" data-testid="shein-category-tree">
      <p className="spo-shop-info__panel-hint">{fixedUi("按层级浏览可用类目；发品时请选择末级分类。")}</p>

      {loading ? <p className="spo-return-detail__empty">{fixedUi("正在查询商品分类…")}</p> : null}
      {error ? <p className="spo-shop-info__inline-error" role="alert">{error}</p> : null}

      {!loading && !error ? (
        <div className="spo-shop-info__category-body">
          <CategoryCascader categories={categories} />
        </div>
      ) : null}
    </div>
  );
}
